module.exports = __webpack_public_path__ + "img/mukaidono.c79560e3.jpg";